import ExecutaRest from '../util/ExecutaRest'

class ufApi {

    static listarUF() {

        var rest = new ExecutaRest();

        return new Promise(function (resolve, reject) {

            rest.Post('UFSL.svc/rest/ListarUFREST', null).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
            }).catch(error => {
                reject('Ocorreu um erro inesperado em --> listarUF: ' + error /*areaTratamento.statusText*/);
            });

        });
        
    }

}

 
 export default ufApi;


/** WEBPACK FOOTER **
 ** ./src/components/api/ufApi.js
 **/